// ======================================================================
// File Name       : ScoringReportAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import { MANAGEMENT_AUTHORITY_TYPE } from '../constants/AuthorityConstant';
import {
  DEFAULT_DATE_FORMAT_SERVER,
  RETURN_MAX_NUM,
  SELECT_TARGET_DATA
} from '../constants/index';
import { USER_TYPE } from '../constants/KeyValueConstants';
import * as ModalIds from '../constants/ModalIds';
import * as ScoringReportConstants from '../constants/ScoringReportConstants';
import * as ScoringReportActionCreator from './actionCreators/scoringReport';
import * as GroupAction from './GroupAction';
import * as groupRequests from './httpRequests/group';
import * as scoringReportRequests from './httpRequests/scoringReport';
import { openModal } from './ModalAction';
import * as userAction from './UserAction';
import { USER_CREATE_TYPE } from '../constants/UserConstants';

export function openReportDialog(data) {
  return (dispatch, getState) => {
    dispatch(ScoringReportActionCreator.receiveReportData(data));
    dispatch(openModal(ModalIds.REPORT_MODAL_DIALOG));
  };
}


export function openGroupSelectDialog() {
  return (dispatch, getState) => {
    const { scoringReport, form, group } = getState();
    const { reportList } = scoringReport;
    reportList.data = { ...form.reportListForm.values };
    const selectedTargetGroup = {
      ...group.selectedTargetGroup,
      groupName: reportList.data.groupSubmitter,
    };
    dispatch(ScoringReportActionCreator.openedGroupSelectDialog(reportList));
    dispatch(GroupAction.selectedGroupOnDialog(selectedTargetGroup));
    dispatch(openModal(ModalIds.SELECT_GROUP_DIALOG));
  };
}

export function removeGroupSelectDialog(selectedTargetGroup) {
  return (dispatch, getState) => {
    const { scoringReport, form, group } = getState();
    const { reportList } = scoringReport;
    reportList.data = { ...form.reportListForm.values };
    dispatch(ScoringReportActionCreator.openedGroupSelectDialog(reportList));
    dispatch(GroupAction.selectedGroupOnDialog(selectedTargetGroup));
  };
}

export function initReportListSearchData(data, isValidUrl, mode) {
  return (dispatch) => {
    dispatch(ScoringReportActionCreator.doInitReportListSearchData(data, isValidUrl, mode));
  };
}

export function fetchGroupStructure() {
  return dispatch =>
    groupRequests
      .postGroupGetStructure()
      .then(({ groupList }) => dispatch(ScoringReportActionCreator.doReceiveGroupStructureList(groupList)));
}

export function selectedGroupFromDialog(selectedTargetGroup) {
  return (dispatch, getState) => {
    const { scoringReport, form } = getState();
    const { reportList } = scoringReport;
    reportList.data.groupSubmitter = selectedTargetGroup.groupName;
    dispatch(ScoringReportActionCreator.doSelectedGroupFromDialog(reportList));
  };
}

export function scoringReportSearch(type, searchInfo, state, mode) {
  return (dispatch, getState) => {
    // get scoringManagementAuthority
    const { authed } = getState();
    const { managementFunctionAuthorityInfo, userInfo } = authed.authedUser;
    const { scoringManagementAuthority } = managementFunctionAuthorityInfo;
    // Step 11.2.0 START
    const userSecernId = userInfo.representationUserSecernId
      ? userInfo.representationUserSecernId
      : userInfo.userSecernId;
    // Step 11.2.0 END
    let userList = [];
    let checkerList = [];
    const groupListRequest = [];
    const statusList = [];
    const reportList = [];
    const request = [];
    // ticket #5854: add parameters into search condistion.
    if (searchInfo.reportId && parseInt(searchInfo.reportId, 10) > 0) {
      reportList.push(searchInfo.reportId);
    }
    const updatedDateFrom = searchInfo.updatedDateFrom && moment(searchInfo.updatedDateFrom).startOf('day')
    .format(DEFAULT_DATE_FORMAT_SERVER);
    const updatedDateTo = searchInfo.updatedDateTo && moment(searchInfo.updatedDateTo).endOf('day')
    .format(DEFAULT_DATE_FORMAT_SERVER);
    const reportSubmitDateFrom = searchInfo.submissionDateFrom &&
      moment(searchInfo.submissionDateFrom).startOf('day').format(DEFAULT_DATE_FORMAT_SERVER);
    const reportSubmitDateTo = searchInfo.submissionDateTo &&
      moment(searchInfo.submissionDateTo).endOf('day').format(DEFAULT_DATE_FORMAT_SERVER);
    if (searchInfo.submitted) statusList.push(ScoringReportConstants.REPORT_STATUS_ID.SUBMITTED);
    if (searchInfo.checking) statusList.push(ScoringReportConstants.REPORT_STATUS_ID.CHECKING);
    if (searchInfo.remand) statusList.push(ScoringReportConstants.REPORT_STATUS_ID.REMAND);
    if (searchInfo.pendingApproval) statusList.push(ScoringReportConstants.REPORT_STATUS_ID.PENDING_APPROVAL);
    if (searchInfo.approved) statusList.push(ScoringReportConstants.REPORT_STATUS_ID.APPPROVED);
    if (searchInfo.resultReturned) statusList.push(ScoringReportConstants.REPORT_STATUS_ID.RESULT_RETURN);
    // set default status when user login not have approved permission
    if (scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE &&
      (!statusList || statusList.length === 0)) {
      statusList.push(ScoringReportConstants.REPORT_STATUS_ID.SUBMITTED);
      statusList.push(ScoringReportConstants.REPORT_STATUS_ID.CHECKING);
      statusList.push(ScoringReportConstants.REPORT_STATUS_ID.REMAND);
      statusList.push(ScoringReportConstants.REPORT_STATUS_ID.PENDING_APPROVAL);
    }
    const isUserSubmitter = searchInfo.userSubmitter;
    const isCheckerName = searchInfo.checkerName;
    const isGropuSubmiter = searchInfo.selectedTargetGroup && searchInfo.selectedTargetGroup.groupSecernId;
    if (searchInfo && searchInfo.selectedTargetGroup && searchInfo.selectedTargetGroup.groupSecernId) {
      groupListRequest.push(searchInfo.selectedTargetGroup.groupSecernId);
      // delete searchInfo.selectedTargetGroup;
    }
    if (isUserSubmitter) {
      if (isGropuSubmiter) {
        request.push(userAction.searchUserCustomParams(
          { userName: searchInfo.userSubmitter, userType: USER_TYPE.STUDENT, groupList: groupListRequest }));
      } else {
        request.push(userAction.searchUserCustomParams({ userName: searchInfo.userSubmitter, userType: USER_TYPE.STUDENT }));
      }
    }
    const shouldSearchUserName = isCheckerName && mode !== ScoringReportConstants.REPORT_LIST_MODE.GET;
    if (shouldSearchUserName) {
      request.push(
        userAction.searchUserCustomParams({
          userName: searchInfo.checkerName,
          userType: USER_TYPE.ADMIN,
          userCreateType: USER_CREATE_TYPE.DEFINED_AND_REPRESENTATIVE_USER, // Step 11.0.0
        }),
      );
    }

    // prepare params to get report list

    const params = {
      searchInfo: {
        reportList,
        reportName: searchInfo.reportName,
        noSetCheckerFlg: searchInfo.noSetCheckerFlg ? 1 : 0,
        reportStatusList: statusList,
        includeDeadlineReportFlg: searchInfo.includeDeadlineReportFlg ? 1 : 0,
        reportHistorySortType: state.reportHistorySortType,
        ascendingDescendingSort: state.ascendingDescendingSort,
        startPosition: state.startPosition,
        returnMaxNum: RETURN_MAX_NUM,
      },
      selectTargetData: type,
    };
    // 5854
    if (searchInfo.displayDate === MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT) {
      params.searchInfo.reportSubmitDateFrom = reportSubmitDateFrom;
      params.searchInfo.reportSubmitDateTo = reportSubmitDateTo;
    } else {
      params.searchInfo.updatedDateFrom = updatedDateFrom;
      params.searchInfo.updatedDateTo = updatedDateTo;
    }
    if (!isUserSubmitter && !isCheckerName) {
      let checkerUserList = [];
      if (scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE &&
        userSecernId) {
      // set checker id is user_secern_id loged in
        checkerUserList = ['', userSecernId];
      }
      params.searchInfo.groupList = groupListRequest;
      params.searchInfo.checkerUserList = checkerUserList;
      return getReporstAndUsersList(params, dispatch, type, getState);
    } else {
      return Promise.all(request).then((response) => {
        if (response && response[0]) userList = response[0];
        if (response && response[1]) checkerList = response[1];
        // incase of searching checker name
        if (isCheckerName && !isUserSubmitter) {
          userList = [];
          checkerList = response[0];
        }
      // if checker user name is set and response of search user is empty, reset report list
        if (shouldSearchUserName &&
          searchInfo.checkerName &&
          (!checkerList || !checkerList.length)) {
          const result = { recordNum: 0, reportList: [] };
          return dispatch(ScoringReportActionCreator.doReceivedSearchResult(result));
        }

        let checkerUserList = null;
        if (checkerList && checkerList.length) {
          checkerUserList = checkerList;
          if (checkerUserList && checkerUserList.push) {
            checkerUserList.push('');
          }
        } else {
          searchInfo.checkerName && (checkerUserList = checkerList);
        }
        params.searchInfo.userList = userList;
        params.searchInfo.checkerUserList = checkerUserList;
        if ((searchInfo.userSubmitter || (searchInfo.userSubmitter && searchInfo.groupSubmitter)) &&
        (!userList || !userList.length)) {
          const result = { recordNum: 0, reportList: [] };
          return dispatch(ScoringReportActionCreator.doReceivedSearchResult(result));
        } else {
          getReporstAndUsersList(params, dispatch, type, getState);
        }
      });
    }
  };
}
// fix #5588
function getReporstAndUsersList(params, dispatch, type, getState) {
  return scoringReportRequests.scoringReportSearchRequest(params).then((result) => {
    const { disabledButtonList } = getState().scoringReport;
    if (type === SELECT_TARGET_DATA.DATA) {
      const listLength = result.reportList.length;
      const userResultList = [];
      for (let i = 0; i < listLength; i++) {
        if (userResultList.indexOf(result.reportList[i].submitterUserSecernId) < 0) {
          userResultList.push(result.reportList[i].submitterUserSecernId);
        }
        if (userResultList.indexOf(result.reportList[i].checkerUserSecernId) < 0) {
          userResultList.push(result.reportList[i].checkerUserSecernId);
        }
        const itemLearningHistoryReportIdAuto = result.reportList[i].itemLearningHistoryReportIdAuto.toString();
        if (disabledButtonList.indexOf(itemLearningHistoryReportIdAuto) >= 0 &&
          result.reportList[i].reportStatus == ScoringReportConstants.REPORT_STATUS_ID.SUBMITTED) {
          result.reportList[i].isDisabled = true;
        }
      }
      if (userResultList.length > 0) {
        dispatch(userAction.searchUserName({ userSecernIdList: userResultList, userCreateType: USER_CREATE_TYPE.DEFINED_AND_REPRESENTATIVE_USER }));
      }
      return dispatch(ScoringReportActionCreator.doReceivedSearchResult(result));
    } else if (type === SELECT_TARGET_DATA.CSV) {
      const link = document.createElement('a');
      link.href = result.csvfileUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  });
}

export function editByCorrector(param) {
  return (dispatch, getState) => {
    return scoringReportRequests.scoringReportEdit(param).then((result) => {
      result.reportOperationType = param.reportOperationType;
      return dispatch(ScoringReportActionCreator.receiveEditByCorrector(result));
    });
  };
}

export function getDetailDrill(itemLearningHistoryIdAuto, itemLearningHistoryReportIdAuto, questionSecernId) {
  const param = {
    itemLearningHistoryReportIdAuto,
    itemLearningHistoryIdAuto,
    questionSecernId,
  };
  return dispatch => scoringReportRequests.getDrilLDetailRequest(param).then((camelizeJson) => {
    dispatch(ScoringReportActionCreator.receiveGetDetailDrill(camelizeJson));
  });
}

export function setExistedDetailDrill(detailDrill) {
  return async (dispatch) => {
    await dispatch(ScoringReportActionCreator.receiveGetDetailDrill(detailDrill));
  };
}

export function saveModalReport(modalReport) {
  return (dispatch, getState) => {
    dispatch(ScoringReportActionCreator.receiveSaveModalReportData(modalReport));
  };
}

export function resetReportList() {
  return (dispatch) => {
    dispatch(ScoringReportActionCreator.resetReportList());
  };
}
// Reset detail drill
export function resetDrillDetail() {
  return (dispatch) => {
    dispatch(ScoringReportActionCreator.resetDrillDetail());
  };
}

export function scoringReportSearchInModal(modalReport) {
  return async (dispatch) => {
    const params = {
      searchInfo: {
        reportList: [modalReport.itemLearningHistoryReportIdAuto],
      },
      selectTargetData: SELECT_TARGET_DATA.DATA,
    };
    const result = await scoringReportRequests.scoringReportSearchRequest(params)
    let data = {};
    if (result.reportList && result.reportList[0]) {
      data = result.reportList[0];
    }
    return dispatch(ScoringReportActionCreator.receiveSaveModalReportData(data));
  };
}

export function handleButtonDisabled(buttonId) {
  return (dispatch) => {
    dispatch(ScoringReportActionCreator.handleButtonDisabled(buttonId));
  };
}

// #7404 START
export function getDrillTopInfo(param) {
  return async (dispatch) => {
    const result = await scoringReportRequests.getDrillTopInfo(param);
    return dispatch(ScoringReportActionCreator.receivedDrillTopInfo(result));
  };
}

export function getEachQuestion(param) {
  return async (dispatch) => {
    const result = await scoringReportRequests.getEachQuestion(param);
    return dispatch(ScoringReportActionCreator.receivedEachQuestion(result));
  };
}
// #7404 END
